import React from "react";
import { Modal, Button } from "react-bootstrap";

const DeleteUserModal = ({ show, handleClose, user, onConfirm }) => {
  if (!user) {
    return null;
  }

  return (
    <Modal show={show} onHide={handleClose} centered size="md" className="bs_common_modal user-status-modal">
      <Modal.Header closeButton>
        <Modal.Title>Delete User</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="dialog-content-body">
          Are you sure you want to delete <b>{user.firstname} {user.lastname}</b>?
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="danger" onClick={onConfirm}>
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteUserModal;
